module.exports = __webpack_public_path__ + "static/media/LOVES_THE_WATRER.b9035124.svg";